var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10487_18474)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10487_18474)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00146484,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFEEB3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.6097,
    y: 20.9444,
    width: 12.6667,
    height: 3.22222,
    rx: 1.61111,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10487_18474)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.88803,
    y: 33.6514,
    width: 24.1111,
    height: 25.5556,
    rx: 12.0556,
    transform: "rotate(-16 4.88803 33.6514)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3874,
    y: 27.0556,
    width: 6.77778,
    height: 3.22222,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5541,
    y: 26.8889,
    width: 6.44444,
    height: 4.44444,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8318,
    y: 12.4999,
    width: 10.2222,
    height: 16.1111,
    rx: 5.11111,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9985 17.6666H15.8876L14.9985 19.7781V17.6666Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8875 17.6666H23.9984L24.8875 19.7781V17.6666Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_10487_18474",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8724 31.2221C25.6539 32.9515 23.0828 34.3164 19.943 34.3164C16.8215 34.3164 14.2619 32.9673 14.0177 31.2521C9.83647 32.4496 6.77637 36.3008 6.77637 40.8667V48.4223H33.2208V40.8667C33.2208 36.2619 30.1084 32.384 25.8724 31.2221Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8724 31.2221C25.6539 32.9515 23.0828 34.3164 19.943 34.3164C16.8215 34.3164 14.2619 32.9673 14.0177 31.2521C9.83647 32.4496 6.77637 36.3008 6.77637 40.8667V48.4223H33.2208V40.8667C33.2208 36.2619 30.1084 32.384 25.8724 31.2221Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8724 31.2221L25.9606 30.9006L25.5899 30.7989L25.5417 31.1803L25.8724 31.2221ZM14.0177 31.2521L14.3477 31.2051L14.2937 30.8263L13.9259 30.9317L14.0177 31.2521ZM6.77637 48.4223H6.44303V48.7556H6.77637V48.4223ZM33.2208 48.4223V48.7556H33.5541V48.4223H33.2208ZM25.5417 31.1803C25.4521 31.8895 24.8662 32.5886 23.8483 33.1226C22.8411 33.651 21.4682 33.9831 19.943 33.9831V34.6498C21.5576 34.6498 23.0402 34.2994 24.158 33.713C25.2653 33.1321 26.0743 32.284 26.2031 31.2639L25.5417 31.1803ZM19.943 33.9831C18.4268 33.9831 17.0609 33.6549 16.0552 33.1317C15.039 32.6031 14.448 31.9098 14.3477 31.2051L13.6877 31.2991C13.8316 32.3096 14.6425 33.1484 15.7476 33.7232C16.8631 34.3034 18.3377 34.6498 19.943 34.6498V33.9831ZM7.1097 40.8667C7.1097 36.4535 10.0674 32.7302 14.1094 31.5726L13.9259 30.9317C9.60551 32.169 6.44303 36.1481 6.44303 40.8667H7.1097ZM7.1097 48.4223V40.8667H6.44303V48.4223H7.1097ZM33.2208 48.089H6.77637V48.7556H33.2208V48.089ZM32.8875 40.8667V48.4223H33.5541V40.8667H32.8875ZM25.7843 31.5436C29.8791 32.6668 32.8875 36.4159 32.8875 40.8667H33.5541C33.5541 36.1079 30.3376 32.1013 25.9606 30.9006L25.7843 31.5436Z",
    fill: "#111111",
    mask: "url(#path-11-inside-1_10487_18474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.633 14.2963L24.6397 14.3097L24.6487 14.3218C24.9398 14.7094 25.1249 14.9772 25.2586 15.2603C25.3913 15.5411 25.4771 15.8448 25.5567 16.3061L25.5562 16.3062L25.5592 16.3182C25.72 16.9613 25.7209 17.7949 25.7209 18.2777C25.7209 18.6512 25.6177 22.1856 25.5737 23.6752C25.5601 24.1346 25.7643 24.5714 26.1234 24.8565H25.069L25.0782 20.2163V20.216V19.832V19.5312L24.8232 19.6907C24.4335 19.9344 24.111 20.0782 23.752 20.163C23.3907 20.2482 22.9843 20.2756 22.4219 20.2757C21.4839 20.2317 20.6497 19.6404 20.0693 18.8549C19.6095 18.2326 18.9373 17.6914 18.1175 17.6533L15.2843 17.5217C15.1299 17.5145 14.9993 17.6348 14.9938 17.7892L14.9331 19.4885L14.933 19.4885L14.933 19.4901L14.7894 24.9212H13.9933C13.978 24.9212 13.9691 24.9168 13.9631 24.9122C13.9562 24.9068 13.9497 24.8982 13.946 24.8869C13.9423 24.8757 13.9424 24.8649 13.9449 24.8564C13.947 24.8492 13.9516 24.8404 13.9639 24.8313C14.2712 24.6061 14.4485 24.2445 14.4385 23.8636L14.2766 17.6841C14.3409 16.1093 14.9577 14.6665 16.119 13.6005L16.119 13.6005L16.12 13.5996C16.5905 13.1609 17.1239 12.8157 17.6892 12.5642L17.7609 12.5367C19.2059 11.9825 20.8006 11.9585 22.2615 12.4689C23.1662 12.8438 23.9799 13.4671 24.6086 14.2475L24.633 14.2963Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.333333
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.748535,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10487_18474"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00146484,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10487_18474"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.00146484,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10487_18474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4444,
    height: 35.5556,
    fill: "white",
    transform: "translate(7.77637 2.66669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric06);
export default __webpack_public_path__ + "static/media/Generic 06.d6c80ebfd65a7df08d1660470a763b11.svg";
export { ForwardRef as ReactComponent };